var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1366(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3999",
    d: "M20.1331 6.76825V25.0569C20.1331 25.885 19.459 26.5564 18.6274 26.5564H2.84069C2.00914 26.5564 1.33496 25.885 1.33496 25.0569V2.99166C1.33496 2.1635 2.00914 1.49218 2.84069 1.49218H14.8351C15.2344 1.49218 15.6174 1.65015 15.8998 1.93132L19.6921 5.70791C19.9745 5.98913 20.1331 6.37055 20.1331 6.76825Z",
    stroke: "#404040",
    strokeWidth: 1.25321,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path737",
    d: "M6.34961 14.2577L9.52971 17.7844L15.3437 11.5183",
    stroke: "#404040",
    strokeWidth: 1.87982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1366);
export default __webpack_public_path__ + "static/media/1366.8d1a4e4cff23d7b933ec1eb629861a0b.svg";
export { ForwardRef as ReactComponent };